export default __webpack_public_path__ + "static/media/resources_blue_icon.be8d0f45.svg";